import React from 'react';
import { InboxIcon } from '@heroicons/react/24/outline';

const EmptyState = ({ title = 'Nenhum resultado', description = '', action }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    <InboxIcon className="w-12 h-12 text-gray-300 mb-3" />
    <h3 className="text-base font-medium text-gray-700">{title}</h3>
    {description && <p className="text-sm text-gray-400 mt-1 max-w-xs">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;
